import React, { useCallback } from "react";

import { faImage } from "@fortawesome/pro-solid-svg-icons/faImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSlate } from "slate-react";

import ImageUploadCallback from "../../type/ImageUploadCallback";
import selectImage from "../../util/selectImage";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

interface ImageInsertProps {
  onImageUpload: ImageUploadCallback;
}

const ImageInsert = ({ onImageUpload }: ImageInsertProps) => {
  const editor = useSlate();

  const handleAction = useCallback(() => {
    selectImage(editor, onImageUpload);
  }, [editor, onImageUpload]);

  return (
    <ActionTooltipWrapper translationString={"ui.emailBody.toolbar.image"}>
      <ToggleButton onClick={handleAction}>
        <FontAwesomeIcon icon={faImage} size="xs" />
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default ImageInsert;
